import { createStore } from '../_core/createStore';
import { lazyDependency } from '../_core/lazyDependency';
import { pickState } from '../_core/pickState';
import useAnalyticStore from '../analyticStore/useAnalyticStore';
import useApiStore from '../apiStore/useApiStore';
import useAttributionStore from '../attributionStore/useAttributionStore';
import useUserStore from '../userStore/useUserStore';
import { keysToPersist, loanDocumentStore } from './loanDocumentStore';

const useNewLoanDocumentStore = createStore({
  creator: loanDocumentStore({
    revokeObjectURL: URL.revokeObjectURL,
    useAnalyticStore: lazyDependency(() => useAnalyticStore),
    useApiStore: lazyDependency(() => useApiStore),
    useAttributionStore: lazyDependency(() => useAttributionStore),
    useUserStore: lazyDependency(() => useUserStore),
  }),
  id: 'newLoanDocument',
  middlewares: {
    devtools: true,
    persist: {
      partialize: (state) => pickState(state, keysToPersist),
    },
  },
});

export default useNewLoanDocumentStore;
